import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-cabecera',
  templateUrl: './cabecera.component.html',
  styleUrls: ['./cabecera.component.css']
})
export class CabeceraComponent implements OnInit {

  constructor() { }

  usuario = '';
  role = '';
  fecha = '';
  @Input() lugar;

  ngOnInit() {
   this.usuario = localStorage.getItem('usuario');
    this.role = localStorage.getItem('role');
    this.fecha =  localStorage.getItem('fecha');
    console.log(this.fecha);
  }



}



// WEBPACK FOOTER //
// H:/Proyectos Galeras Indie/Vinta/vinta Tinka/VintaWebClient/src/app/cabecera/cabecera.component.ts